import { AlertTriangle, CheckCircle2, GitMerge } from "lucide-react";

import type { SaveResult } from "@/api/db/person-write";
import { Chip } from "@/components/people/field";
import { CadastroLabels } from "@/lib/labels";

const SAVE_ERROR_MESSAGE = "Não foi possível salvar o cadastro.";

export function SaveErrorFeedback() {
	return (
		<div
			data-component="cadastro-feedback"
			data-outcome="error"
			className="flex items-center gap-2 rounded-lg border border-destructive/25 bg-destructive/5 p-4 text-sm font-medium text-destructive"
		>
			<AlertTriangle className="size-4 shrink-0" />
			<span data-slot="error">{SAVE_ERROR_MESSAGE}</span>
		</div>
	);
}

export function SaveFeedback({ result }: { result: SaveResult }) {
	const flags = CadastroLabels.savedFlags(result);
	const linked = result.outcome === "linked";

	return (
		<div
			data-component="cadastro-feedback"
			data-outcome={result.outcome}
			data-facet={result.facet}
			data-birth-suspect={result.birth_suspect}
			data-suspected-non-patient={result.suspected_non_patient}
			className="flex flex-col gap-2 rounded-lg border border-info/25 bg-info/5 p-4"
		>
			<div className="flex items-center gap-2 text-sm font-medium text-foreground">
				{linked && <GitMerge className="size-4 text-primary" />}
				{!linked && <CheckCircle2 className="size-4 text-info" />}

				<span data-slot="outcome">{CadastroLabels.outcome[result.outcome]}</span>

				<Chip tone="petrol">{CadastroLabels.facet[result.facet]}</Chip>
			</div>

			{flags.length > 0 && (
				<ul className="flex flex-col gap-1.5">
					{flags.map((flag) => (
						<li
							key={flag}
							data-slot={`flag-${flag}`}
							className="flex items-start gap-2 text-sm text-destructive"
						>
							<AlertTriangle className="mt-0.5 size-4 shrink-0" />
							{CadastroLabels.cleaningFlag[flag]}
						</li>
					))}
				</ul>
			)}
		</div>
	);
}
